<template>
<div id="ServiceCodePrereqServiceCodesAddEdit">

<form>
  
  <div class="form-group row my-1">
    <label for="tooth" class="col-sm-4 label-small my-0">Tooth Number:</label>
    <div class="col-sm-4 my-0">
      <input id="tooth"   maxlength="2" v-model="tooth" placeholder="Tooth Number" class="mb-0 form-control form-control-xs">
    </div>
  </div>

  <div class="form-group row" v-show="$v.tooth.$error" > 
    <small class="sml-red ml-3" v-if="!$v.tooth.required">Tooth number is required</small>
    <small class="sml-red ml-3" v-if="!$v.tooth.numeric && $v.tooth.required">Tooth number must be a number</small>
    <small class="sml-red ml-3" v-if="!$v.tooth.Duplicate && $v.tooth.required">Tooth number already added</small>
  </div>

     
<hr>
<div class="row" >
    <div class="col-sm-8" >
            <button v-on:click="SavePopup" :disabled="disableSave" type="button" class="btn BtnSave  btn-sml"><i :class="saveIcon"></i> {{btnName}} </button>
    </div>
    <div class="col-sm-4">
        <button v-on:click="ClosePopup" type="button" class="btn BtnClose btn-sml float-right"><i class="fas fa-times"></i> Close Form </button>
    </div>
</div>

</form>
</div>

</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import Vuelidate from 'vuelidate'
import { helpers } from 'vuelidate/lib/validators'

Vue.use(Vuelidate)
import { required, minLength, maxLength, between,withParams,email,numeric} from 'vuelidate/lib/validators'
import { notEqual } from 'assert'; 
export default {
    props:{
        UserData:'',
        mode:'',
        DataSet:'',
        UserRow:'',
    },
  data: function(){
    return{
        saveIcon:'fas fa-plus',
        btnName: 'Add Tooth Number Allowed',
        succeeded:true,
        showModal:false,
        showModal:false,
        Msg:'',
        EditMode:'',
        disableSave:false,
        tooth:'',
        tabledata:'',
        editedRow:''
    }   
  },
  created: function(){
    this.EditMode = this.mode;

    if(this.EditMode  == 'Edit')
    {
        this.btnName = 'Edit Tooth Number Allowed';
        this.saveIcon = 'far fa-edit'; 
    } 
    this.tooth = this.UserData.tooth;
    this.tabledata = this.DataSet;
    this.editedRow = this.UserRow;
  },
methods: {
  ClosePopup: function() {     
      this.$root.$emit('bv::hide::modal', 'ServiceCodeToothNumberAllowedAddEdit', '#btnShow') 
         //this.$v.$reset();
    },
    SavePopup: function(){
       this.$v.$touch();

      if (!this.$v.$invalid){
          this.$emit('ServiceCodeToothNumberUpdate', this.tooth)
          this.showModal=false;
      }
    },
},
  validations(){
    return {
        tooth:{
            required,
            numeric,
            Duplicate: value=> this.tabledata.findIndex(x=>x.tooth == this.tooth)== -1 || this.tabledata.findIndex(x=>x.tooth == this.tooth) == this.editedRow
        }
    }
  }
}
</script>

<style>

</style>
